import { Pipe, PipeTransform } from "@angular/core";
import { RoundingFormatterService } from "../models/rounding-formatter.service";

@Pipe({
  name: "roundingFormatter"
})
export class RoundingFormatterPipe implements PipeTransform {
  constructor(private roundingFormatterService: RoundingFormatterService) {}
  transform(value: number | string, fractionSize: number = 2): any {
    return this.roundingFormatterService.transform(value, fractionSize);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipe/rounding-formatter.pipe.ts